import { MenuItem, TextField } from "@mui/material";
import React from "react";
import mut from "../hooks/mut";
import Lang from "./Lang";


/**
 * SelectFromList
 * 
 * A component that displays a select of choices. If the choices are an array of strings, the component will be a TextField with a select attribute. If the choices are an array of objects with {_id,name}, the component will be a TextField with a select attribute.
 * 
 * @param {Array} choices the array of choices, either array of string or array of objects with {_id,name}
 * @param {string} value the current value of the component
 * @param {function} setValue a function to call when the value changes
 * @param {string} label the label to display above the component
 * @param {string} style the style to apply to the component
 * @param {string} size the size of the component
 * @param {boolean} none if true, display a "None" option
 * @param {boolean} fullWidth if true, the component will take up all the width available
 * @param {string} url optional, the url to post to when the value changes
 * @param {string} field optional, the field to update when the value changes
 * 
 * @returns a JSX element
 */
export default function SelectFromListField(props) {
  const { choices, object, setObject, style, label, size, none, fullWidth, url, field } = props

  const change = (val) => {
    console.log(val)
    if (url && field) {
      mut("post",url,{[field]:val})
    }
    setObject(prev=>({...prev,[field]:val}))
  }
  
  if(!choices || choices.length===0) return <div></div>  

  if (typeof choices[0] === "object")return (
    <TextField
      size={size}
      label={label}
      style={style}
      value={object[field]}
      select
      onChange={(e) => change(e.target.value)}
      fullWidth={fullWidth}
      {...props}
    >
      {none ? (
        <MenuItem
          value=""
          key="none"
        >
          <Lang w="none" />
        </MenuItem>
      ) : null}
      {choices.map((choice) => (
        <MenuItem
          value={choice._id}
          key={choice._id}
        >
          {choice.name}
        </MenuItem>
      ))}
    </TextField>
  );
    
    return (
      <TextField
        size={size}
        label={label}
        style={style}
        value={object[field]}
        select
        onChange={(e) => change(e.target.value)}
        fullWidth={fullWidth}
        {...props}
      >
        {none ? (
          <MenuItem value="" key="none">
            None
          </MenuItem>
        ) : null}
        {choices.map((choice,i) => (
          <MenuItem value={choice} key={choice+i}>
            {choice}
          </MenuItem>
        ))}
      </TextField>
    );


    
}